import{m as e}from"./chunk-HBP5N4FR.js";e();var o=`.dapp-core-component__styles__decode {
  margin-top: 0.25rem;
  position: relative;
  max-width: 100%;
  flex: 1;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea {
  -moz-appearance: textfield-multiline;
  -webkit-appearance: textarea;
  border: 1px solid #dee2e6;
  background-color: #fafafa;
  font-size: 0.8125rem;
  min-height: 3.125rem;
  height: 4.5rem;
  overflow: auto;
  padding: 0.375rem 6rem 0.375rem 0.75rem;
  word-wrap: break-word;
  white-space: pre-wrap;
  resize: vertical;
  scrollbar-width: thin;
  overflow-x: hidden;
  width: 100%;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea:hover {
  border: 1px solid #dee2e6;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .dapp-core-component__styles__decode .dapp-core-component__styles__textarea:before {
    background: #fafafa;
    content: "";
    bottom: 1px;
    right: 1px;
    width: 16px;
    height: 16px;
    position: absolute;
    cursor: ns-resize;
  }
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .dapp-core-component__styles__decode .dapp-core-component__styles__textarea:after {
    content: "";
    bottom: 0;
    right: 0;
    width: 16px;
    height: 16px;
    position: absolute;
    -webkit-clip-path: polygon(80% 0, 80% 80%, 0 80%);
    clip-path: polygon(80% 0, 80% 80%, 0 80%);
    cursor: ns-resize;
    background: repeating-linear-gradient(135deg, #dee2e6, #dee2e6 1px, transparent 0, transparent 3px);
  }
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-scrollbar {
  background-color: #fafafa;
  width: 1rem;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-scrollbar-track {
  background-color: #fafafa;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-scrollbar-track:hover {
  background-color: #fafafa;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-scrollbar-thumb {
  background-color: #dee2e6;
  border-radius: 1rem;
  border: 5px solid #fafafa;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #fafafa;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-scrollbar-button {
  display: none;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__textarea::-webkit-resizer {
  background-color: transparent;
}
@-moz-document url-prefix() {
  .dapp-core-component__styles__decode:before, .dapp-core-component__styles__decode:after {
    display: none;
  }
}
.dapp-core-component__styles__decode .dapp-core-component__styles__select {
  right: 0.313rem;
  top: 0.313rem;
  position: absolute;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__select:after {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  top: calc(50% + 1px);
  transform: translateY(-50%);
  left: calc(50% + 0.5rem);
  border-top: 0.25rem solid;
  border-right: 0.25rem solid transparent;
  border-bottom: 0;
  border-left: 0.25rem solid transparent;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__select .dapp-core-component__styles__dropdown {
  appearance: none;
  text-align: center;
  padding: 0.25rem 0.5rem;
  text-indent: -10px;
  font-size: 0.6875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  background-color: transparent;
  border: 1px solid #e4e5e5;
  transition: all 400ms ease;
  cursor: pointer;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__select .dapp-core-component__styles__dropdown:hover {
  background-color: #eeeeee;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__select .dapp-core-component__styles__dropdown:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.13);
  background-color: #eeeeee;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__select .dapp-core-component__styles__dropdown:focus {
  outline: none;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__warnings {
  display: flex;
  align-items: center;
  margin-right: 0.25rem;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__warnings .dapp-core-component__styles__icon {
  margin-right: 0.25rem;
  color: #f0ad4e;
}
.dapp-core-component__styles__decode .dapp-core-component__styles__warnings .dapp-core-component__styles__warning {
  color: #f0ad4e;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));var n={decode:"dapp-core-component__styles__decode",textarea:"dapp-core-component__styles__textarea",select:"dapp-core-component__styles__select",dropdown:"dapp-core-component__styles__dropdown",warnings:"dapp-core-component__styles__warnings",icon:"dapp-core-component__styles__icon",warning:"dapp-core-component__styles__warning"};export{o as a,n as b};
//# sourceMappingURL=chunk-E6XKSJC4.js.map
